export default "__VITE_ASSET__BXGdg7jJ__"